/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BidManagementListOrderRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: BidManagementListOrderRequest.direction | null;
    name?: string | null;
    code?: string | null;
    title?: string | null;
    livecarpId?: number;
    status?: string | null;
    startDate?: string | null;
    endDate?: string | null;
};

export namespace BidManagementListOrderRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

